import { Cartesian3, Cartographic, CatmullRomSpline, Color, JulianDate, KmlDataSource, LinearSpline, Math as MathCesium, Matrix4, PolylineGlowMaterialProperty, SampledPositionProperty, ScreenSpaceEventType, VelocityOrientationProperty } from "cesium";
import '../styles/flycamera.css'
import { IconTrash } from "../icon";
import { createUUID } from "../utils/utils";
import { DialogGeneral } from "../utils/Dialog/dialog";
import { getMessage } from "../language";


export class FlyCamera {
    viewer: any;
    private handler: any
    containerId: string;
    // Saved clock state to restore after fly animation so we don't affect global day/night
    private savedClockState: { startTime?: any; stopTime?: any; currentTime?: any; multiplier?: number; shouldAnimate?: boolean } | null = null;
    private IdGenneral = createUUID();//Tạo ID ngẫu nhiên khi khởi tạo

    // Thuộc tính để lưu callback
    private onClosedCallback: ((status: boolean) => void) | undefined;
    private dialog: DialogGeneral | undefined;
    private containerBody: any

    private containerFooter: any
    constructor(containerId: string, viewer: any) {
        this.containerId = containerId; // Gán giá trị containerId    
        this.viewer = viewer;//Gán giá trị viewer
        this.createModalSettingCamera()
        this.showHideModalCameraSetting(false)

    }
    // Gán callback từ lớp cha
    setClosedCallback(callback: (status: boolean) => void): void {
        this.onClosedCallback = callback;
    }
    // Gọi callback để thông báo thay đổi trạng thái
    notifyCallBack(status: boolean): void {
        if (this.onClosedCallback) {
            this.onClosedCallback(status); // Thông báo cho lớp cha
            if (!status) {

            }
        } else {
            console.error("State change callback is not set.");
        }
    }
    createModalSettingCamera = () => {
        this.dialog = new DialogGeneral(
            this.containerId,
            this.handleCloseModal
        );
        this.dialog.innerHeader = "Camera";
        this.dialog.isModal = true
        this.dialog.minimizeDialog = true;
        this.dialog.topModal = "50%"
        this.dialog.leftModal = "50%"
        this.dialog.widthModal = "300px"
        this.dialog.heightModal = "550px"
        this.dialog.innerBody = this.renderBodySettingCamera();
        this.dialog.innerFooter = this.renderFooterSettingCamera();
        // Gọi createDialog để tạo modal
        this.dialog.createDialog();

    }
    private handleCloseModal = (status: boolean) => {
        if (!status) {

            this.notifyCallBack(status)

        }
    }

    showHideModalCameraSetting = (show: boolean) => {
        this.dialog?.showModal(show)
    }

    private renderBodySettingCamera = () => {

        this.containerBody = document.createElement('div')
        this.containerBody.className = 'modal-body-setting-fly-camera';
        this.containerBody.innerHTML =
            `
        <div id="list-file-camera-${this.IdGenneral}" class="container-list">
                    <fieldset style="overflow: auto}">
                        <legend>${getMessage("camera-choose-kmz")}</legend>
                                            
                        <div style="width:100%;text-align: center;color: darkgrey;line-height:60px">
                            ${getMessage("camera-choose-kmz-place-holder")}
                        </div>
                    </fieldset> 
            </div>
            <div style="width:100%; display: flex;justify-content: right;padding: 5px 2px 0 0">
                <button id="btn-delete-kmz-${this.IdGenneral}" class="btn-danger-dpu disabled" disabled>${IconTrash()}</button>
            </div>
            <div id="system-camera-${this.IdGenneral}" class="container-form">             
                <div style="margin:0px 0 10px 0"> ${getMessage("camera-distance")}: <span style="font-weight:600" id="total-distance-${this.IdGenneral}">1 (km)</span></div>

                <label>${getMessage("camera-time")}:</label>
                
                <input class="input-camera-setting dpu-input-text" class=""  id="flight-time-${this.IdGenneral}" type="number"  value="80"  min="0" step="1">
               
                <label>${getMessage("camera-speed")} (km/h):</label>
                
                <input class="input-camera-setting dpu-input-text"  id="flight-speed-${this.IdGenneral}" type="number"  value="80" min="0" step="1">
                
                <label>${getMessage("camera-height")} (m):</label>
                               
                <input class="input-camera-setting dpu-input-text" id="height-camera-${this.IdGenneral}"  type="number" value="0" min="0" step="1">
              
                <label>${getMessage("camera-view")}:</label>
                
                <input class="input-camera-setting dpu-input-text" id="angle-camera-${this.IdGenneral}"  type="number"  value="15" min="0" step="1">
               
            </div>
        `
        const btnDeleteKmz = this.containerBody.querySelector(`#btn-delete-kmz-${this.IdGenneral}`);
        if (btnDeleteKmz) {
            btnDeleteKmz.addEventListener('click', () => { this.removeCheckedFromDataSources() });
        }

        //Gọi theo dõi input sau khi render ra được các thẻ
        this.handleTrackInput()
        return this.containerBody
    }

    private renderFooterSettingCamera = () => {

        this.containerFooter = document.createElement('div')
        this.containerFooter.className = 'modal-footer-setting-fly-camera';
        this.containerFooter.innerHTML = `         
           <button id="btn-loadKMZ-${this.containerId}" class ="btn-load-files-kmz " >${getMessage("camera-choose-kmz")}</button>
           <button id="btn-run-camera-${this.containerId}" class="btn-ok-modal disabled"disabled>OK</button>       
        `
        // Gán sự kiện riêng cho các nút không thuộc nhóm
        const btnMapModel = this.containerFooter.querySelector(`#btn-loadKMZ-${this.containerId}`);
        if (btnMapModel) {
            btnMapModel.addEventListener('click', () => this.loadFileKMZ());
        }
        const btnRunCam = this.containerFooter.querySelector(`#btn-run-camera-${this.containerId}`);
        if (btnRunCam) {
            btnRunCam.addEventListener('click', () => { this.moveCameraAlongPath() });
        }
        return this.containerFooter
    }





    pointKML: any = [];
    totalDistanceFly: number = 25;
    dataSources: any = [];  // Mảng lưu trữ các đối tượng { fileName, dataSource }


    private loadFileKMZ = async () => {
        // this.dataSources = [];
        let jsonFileNames = "";
        try {
            const fileHandles = await (window as any).showOpenFilePicker({
                types: [
                    {
                        description: 'KML & KMZ Files',
                        accept: {
                            'application/vnd.google-earth.kmz': ['.kmz'],
                            'application/vnd.google-earth.kml+xml': ['.kml'],
                        },
                    },
                ],
                multiple: true, // Cho phép chọn nhiều file
            });

            const listFileNames: any[] = [];
            const loadPromises: any[] = [];

            for (const fileHandle of fileHandles) {
                const file = await fileHandle.getFile();
                const fileName = file.name;

                // Kiểm tra xem file đã có trong mảng chưa
                const fileExists = this.dataSources.some(
                    (dataSource: { name: any }) => dataSource.name === fileName
                );
                if (fileExists) {
                    console.log(`File '${fileName}' đã tồn tại, bỏ qua.`);
                    continue;
                }

                const reader = new FileReader();

                const loadPromise = new Promise<void>((resolve, reject) => {
                    reader.onload = async (event) => {
                        try {
                            const fileType = fileName.toLowerCase().endsWith('.kmz')
                                ? 'application/vnd.google-earth.kmz'
                                : 'application/vnd.google-earth.kml+xml';
                            const fileUrl = URL.createObjectURL(
                                new Blob([event.target!.result as ArrayBuffer], {
                                    type: fileType,
                                })
                            );

                            // Sử dụng `await` để load file KMZ
                            const dataSource = await KmlDataSource.load(fileUrl);

                            // Gọi hàm xử lý file
                            this.handleFileKmz(dataSource, fileName);
                            console.log(`File '${fileName}' loaded successfully`);
                            resolve();
                        } catch (error) {
                            alert(`Load file '${fileName}' lỗi`);
                            reject(error);
                        }
                    };

                    reader.readAsArrayBuffer(file);
                });

                loadPromises.push(loadPromise);
            }

            // Chờ tất cả các file được tải
            await Promise.all(loadPromises);

            if (this.dataSources.length > 0) {

                this.dataSources.forEach((data: any) => {
                    listFileNames.push({
                        name: data.name,
                        distance: data.distance,
                    });
                });

                jsonFileNames = JSON.stringify(listFileNames);
                // console.log("dataSources", this.dataSources)
                this.updateFileList();
            }
        } catch (error: any) {
            if (error.name === 'AbortError') {
                console.warn("User canceled the file selection.");
            } else {
                console.error(
                    "File selection was cancelled or an error occurred:",
                    error
                );
                alert("Đã xảy ra lỗi khi chọn file KML/KMZ");
            }
            return;
        }
        return jsonFileNames;
    };

    loadFileKmzFromUrl = async (url: string) => {
        let jsonFileNames = "";

        try {
            // Chờ để load KMZ từ URL
            const dataSourceLoad = await KmlDataSource.load(url);

            // Xử lý file KMZ sau khi tải xong
            this.handleFileKmz(dataSourceLoad, dataSourceLoad.name);
            console.log(`KMZ file '${dataSourceLoad.name}' loaded successfully`);

            // Kiểm tra dataSources và xử lý
            if (this.dataSources.length > 0) {

                let listFileNames: any = [];
                this.dataSources.forEach((data: any) => {
                    listFileNames.push({
                        name: data.name,
                        distance: data.distance
                    });
                });

                jsonFileNames = JSON.stringify(listFileNames);

                this.updateFileList();

            }
        } catch (error: any) {
            // Xử lý lỗi khi tải KMZ
            if (error.name === 'AbortError') {
                console.warn("User canceled the file selection.");
            } else {
                console.error("Error occurred while loading the KMZ file:", error);
                alert("Đã xảy ra lỗi khi tải file KMZ");
            }
        }
        return jsonFileNames;
    }



    private handleFileKmz = (dataSource: any, nameFile: any) => {
        //reset lại points
        this.pointKML = []
        let totalDistanceFly = 0;
        // Lấy danh sách các entities từ file KML
        const entities = dataSource.entities.values;

        // Sort lại danh sách các đường thẳng
        const backups = [];
        for (let i = 0; i < entities.length; i++) {
            if (entities[i].polyline) {
                backups.push(entities[i].polyline);
            }
        }


        const newEntities = [backups[0]];
        backups.splice(0, 1)
        for (let i = 0; i < newEntities.length; i++) {
            const dataPoints = newEntities[i].positions.getValue(
                JulianDate.now()
            );
            var endPoint = dataPoints[dataPoints.length - 1];
            for (let j = 0; j < backups.length; j++) {
                const dataPoint1s = backups[j].positions.getValue(
                    JulianDate.now()
                );

                var startPoint = dataPoint1s[0];
                if (Cartesian3.distance(startPoint, endPoint) < 1) {
                    newEntities.push(backups[j]);
                    backups.splice(j, 1);
                    break;
                }
            }
        }


        const controlPoints: any = []; // Các điểm điều khiển cho đường cong
        newEntities.forEach(entity => {

            const positions = entity.positions.getValue(JulianDate.now());
            positions.forEach((position: any) => {
                // Chuyển từ Cartesian sang kinh độ, vĩ độ và độ cao
                const cartographic = Cartographic.fromCartesian(position);
                const longitude = MathCesium.toDegrees(cartographic.longitude);
                const latitude = MathCesium.toDegrees(cartographic.latitude);
                const height = cartographic.height;

                // Chuyển đổi sang Cartesian3 và thêm vào danh sách điểm điều khiển
                const cartesianPoint = Cartesian3.fromDegrees(longitude, latitude, height);
                if (controlPoints.length === 0) {
                    controlPoints.push(cartesianPoint); // Thêm điểm đầu tiên
                } else {
                    // Kiểm tra khoảng cách với điểm cuối cùng trong mảng
                    const lastPoint = controlPoints[controlPoints.length - 1];
                    const distance = Cartesian3.distance(cartesianPoint, lastPoint);

                    totalDistanceFly += distance;
                    controlPoints.push(cartesianPoint);
                    this.pointKML.push(cartesianPoint)
                }
            });

        });
        // Dùng spline để vẽ đường cong mượt mà từ các điểm điều khiển
        if (controlPoints.length > 2) {
            this.dataSources.push({
                name: nameFile,
                distance: totalDistanceFly,
                pointKML: this.pointKML,

            })

        }

    }


    /**
   * Hàm load lại view list File KMZ  
   */
    private updateFileList = () => {
        const container = document.getElementById(`list-file-camera-${this.IdGenneral}`);
        if (!container) {
            console.error(`Container with ID "list-file-camera-${this.IdGenneral}" not found.`);
            return;
        }

        if (this.dataSources.length > 0) {
            // Xóa nội dung cũ trước khi render mới
            container.innerHTML = `
            <fieldset>
                <legend>Chọn file KMZ</legend>
                <div class="list-box"></div>
            </fieldset>
            `;

            const listBox = container.querySelector('.list-box');
            if (!listBox) {
                console.error('List box not found in container.');
                return;
            }

            // Tạo checkbox "Check All"
            const checkAllDiv = document.createElement('div');
            checkAllDiv.className = 'form__group';
            checkAllDiv.style.margin = '5px 0 10px 0';
            checkAllDiv.style.borderBottom = '1px solid darkgray';
            checkAllDiv.style.paddingBottom = '5px';

            const checkAllCheckbox = document.createElement('input');
            checkAllCheckbox.type = 'checkbox';
            checkAllCheckbox.id = `check_all_${this.IdGenneral}`;
            checkAllCheckbox.name = 'check-all';
            checkAllCheckbox.className = 'dpu-input-check-box'
            const checkAllLabel = document.createElement('label');
            checkAllLabel.htmlFor = `check_all_${this.IdGenneral}`;
            checkAllLabel.textContent = getMessage("select-all");

            // Gắn sự kiện cho checkbox "Check All"
            checkAllCheckbox.addEventListener('change', (event) => {
                const isChecked = (event.target as HTMLInputElement).checked;
                const checkboxes = listBox.querySelectorAll('input[type="checkbox"]');
                checkboxes.forEach((checkbox) => {
                    (checkbox as HTMLInputElement).checked = isChecked;
                    const target = checkbox as HTMLInputElement;
                    this.handleCheckboxChange(target.id, target.value, isChecked);
                });
            });

            // Gắn "Check All" vào list-box
            checkAllDiv.appendChild(checkAllCheckbox);
            checkAllDiv.appendChild(checkAllLabel);
            listBox.appendChild(checkAllDiv);

            // Duyệt qua dataSources và tạo checkbox cho mỗi file
            this.dataSources.forEach((dataSource: any, index: number) => {
                const formGroup = document.createElement('div');
                formGroup.className = 'form__group';

                const checkbox = document.createElement('input');
                checkbox.type = 'checkbox';
                checkbox.id = `file_${index}`;
                checkbox.value = dataSource.name;
                checkbox.name = 'file-checkbox';
                checkbox.className = 'dpu-input-check-box'

                const label = document.createElement('label');
                label.htmlFor = `file_${index}`;
                label.textContent = `${dataSource.name}`;

                // Gắn sự kiện lắng nghe thay đổi cho checkbox
                checkbox.addEventListener('change', (event) => {
                    const target = event.target as HTMLInputElement;
                    this.handleCheckboxChange(target.id, target.value, target.checked);

                    // Cập nhật trạng thái của checkbox "Check All"
                    const allChecked = Array.from(listBox.querySelectorAll('input[type="checkbox"]:not([name="check-all"])'))
                        .every((cb) => (cb as HTMLInputElement).checked);

                    checkAllCheckbox.checked = allChecked;
                });

                // Gắn checkbox và label vào form-group
                formGroup.appendChild(checkbox);
                formGroup.appendChild(label);

                // Gắn form-group vào list-box
                listBox.appendChild(formGroup);
            });
        } else {
            container.innerHTML = `
             <fieldset>
                <legend>Chọn file KMZ</legend>
                <div style="width:100%;text-align: center;color: darkgrey;line-height:60px">
                    Vui lòng chọn file KMZ
                </div>
            </fieldset> 
            `;
        }
    };



    /**
    * Hàm theo dỗi checkbox của list
    * @param {string} id id Thẻ
    * @param {string} value  giá trị của checkbox  * 
    * @param {boolean} checked  check/uncheck  * 
    */
    btnDeleteKmz: any;
    btnOkKmz: any;
    checkedFiles: string[] = []; // Danh sách lưu các file được chọn

    private handleCheckboxChange = (id: string, value: string, checked: boolean) => {
        if (!this.btnDeleteKmz || this.btnOkKmz) {
            this.btnDeleteKmz = document.getElementById(`btn-delete-kmz-${this.IdGenneral}`)
            this.btnOkKmz = document.getElementById(`btn-run-camera-${this.containerId}`)
        }

        if (checked) {
            // Thêm vào danh sách nếu được chọn
            if (!this.checkedFiles.includes(value)) {
                this.checkedFiles.push(value);
            }
        } else {
            // Loại bỏ khỏi danh sách nếu bị bỏ chọn
            this.checkedFiles = this.checkedFiles.filter(file => file !== value);
        }

        //Tính toán lại chiều dài đường bay
        if (this.checkedFiles.length > 0) {
            this.btnDeleteKmz.disabled = false;
            this.btnDeleteKmz.classList.remove("disabled")
            this.btnOkKmz.disabled = false;
            this.btnOkKmz.classList.remove("disabled")

            //Khởi tạo lại khoảng cách
            this.totalDistanceFly = 0
            // Duyệt qua dataSources
            this.dataSources.forEach((data: any) => {
                // Kiểm tra nếu tên trong dataSources trùng với tên trong checkedFiles
                if (this.checkedFiles.includes(data.name)) {
                    // Cộng dồn distance từ dataSources
                    this.totalDistanceFly += data.distance;
                }
            })
        } else {
            this.totalDistanceFly = 0
            this.btnDeleteKmz.disabled = true;
            this.btnDeleteKmz.classList.add("disabled")
            this.btnOkKmz.disabled = true;
            this.btnOkKmz.classList.add("disabled")

        }
        //Gán lại giá trị cho Quảng đường bay
        this.totalDistanceElement.textContent = parseFloat((this.totalDistanceFly / 1000).toFixed(2)) + " (km)"

        //Tính toán lại thời gian khi pick vào
        this.validateAndHandleFlightSpeedChange();
    };

    /**
     * Hàm xóa file của list checkbox  
     */
    private removeCheckedFromDataSources = () => {
        // Lọc lại dataSources, chỉ giữ những phần tử không có trong checkedFiles
        this.dataSources = this.dataSources.filter(
            (dataSource: { name: string }) => !this.checkedFiles.includes(dataSource.name)
        );
        this.updateFileList();
        // console.log('Updated dataSources:', this.dataSources);
        this.checkedFiles = []
        this.totalDistanceFly = 1;
        this.flightSpeedInput.value = 1
        this.flightTimeInput.value = 1
        this.totalDistanceElement.textContent = "1 (km)"
        this.btnDeleteKmz.disabled = true;
        this.btnDeleteKmz.classList.add("disabled")
        this.btnOkKmz.disabled = true;
        this.btnOkKmz.classList.add("disabled")

    }



    totalDistanceElement: any
    flightTimeInput: any
    flightSpeedInput: any
    heightCameraInput: any
    angleCameraInput: any
    /**
     * Hàm theo dõi thay đổi của input  
     */
    private handleTrackInput = () => {
        // Tham chiếu đến các phần tử
        this.totalDistanceElement = this.containerBody.querySelector(`#total-distance-${this.IdGenneral}`);
        this.flightTimeInput = this.containerBody.querySelector(`#flight-time-${this.IdGenneral}`);
        this.flightSpeedInput = this.containerBody.querySelector(`#flight-speed-${this.IdGenneral}`);
        this.heightCameraInput = this.containerBody.querySelector(`#height-camera-${this.IdGenneral}`);
        this.angleCameraInput = this.containerBody.querySelector(`#angle-camera-${this.IdGenneral}`);

        // Gán sự kiện lắng nghe thay đổi
        this.flightTimeInput.addEventListener("keydown", this.restrictToIntegerInput);
        this.flightTimeInput.addEventListener("input", this.validateAndHandleFlightTimeChange);

        this.flightSpeedInput.addEventListener("keydown", this.restrictToIntegerInput);
        this.flightSpeedInput.addEventListener("input", this.validateAndHandleFlightSpeedChange);

        this.heightCameraInput.addEventListener("keydown", this.restrictToIntegerInput);
        this.heightCameraInput.addEventListener("input", this.validateAndHandleHeightCameraChange);

        this.angleCameraInput.addEventListener("keydown", this.restrictToIntegerInput);
        this.angleCameraInput.addEventListener("input", this.validateAndHandleAngleCameraChange);
    };

    /**
     * Chặn các ký tự không hợp lệ và chỉ cho phép nhập số nguyên
     */
    private restrictToIntegerInput = (event: KeyboardEvent) => {
        // Cho phép các phím điều khiển: backspace, tab, arrow keys
        if (
            event.key === "Backspace" ||
            event.key === "Tab" ||
            event.key === "ArrowLeft" ||
            event.key === "ArrowRight"
        ) {
            return;
        }

        // Chặn ký tự không phải số
        if (!/^\d$/.test(event.key)) {
            event.preventDefault();
        }
    };

    /**
     * Tính vận tốc bay dựa vào thời gian bay
     * @param {number} time - Thời gian bay (giây)
     * @param {number} distance - Quảng đường bay (km)
     * @returns {number} Vận tốc bay (km/h)
     */
    private calculateSpeed = (time: number, distance: number): number => {
        return distance / (time / 3600); // Quảng đường (km) chia cho thời gian (giờ)
    };

    /**
     * Tính thời gian bay dựa vào vận tốc bay
     * @param {number} speed - Vận tốc bay (km/h)
     * @param {number} distance - Quảng đường bay (km)
     * @returns {number} Thời gian bay (giây)
     */
    private calculateTime = (speed: number, distance: number): number => {
        return (distance / speed) * 3600; // Thời gian (giờ) nhân với 3600 để chuyển sang giây
    };

    /**
     * Xử lý sự kiện khi thay đổi thời gian bay (chỉ chấp nhận số nguyên dương)
     */
    private validateAndHandleFlightTimeChange = () => {
        let flightTime = parseInt(this.flightTimeInput.value, 10);

        // Kiểm tra giá trị hợp lệ
        if (isNaN(flightTime) || flightTime <= 0) {
            flightTime = 0; // Gán giá trị mặc định nếu không hợp lệ
        }

        this.flightTimeInput.value = flightTime; // Đảm bảo hiển thị số nguyên

        // Tính toán và cập nhật vận tốc bay
        const newSpeed = this.calculateSpeed(flightTime, Math.round(this.totalDistanceFly / 1000));
        if (newSpeed === Infinity || isNaN(newSpeed)) {
            this.flightSpeedInput.value = 0
            this.flightTimeInput.value = 0
        } else {
            this.flightSpeedInput.value = Math.round(newSpeed).toString(); // Hiển thị dưới dạng số nguyên
        }

    };

    /**
     * Xử lý sự kiện khi thay đổi vận tốc bay (chỉ chấp nhận số nguyên dương)
     */
    private validateAndHandleFlightSpeedChange = () => {
        let flightSpeed = parseInt(this.flightSpeedInput.value, 10);

        // Kiểm tra giá trị hợp lệ
        if (isNaN(flightSpeed) || flightSpeed <= 0) {
            flightSpeed = 0; // Gán giá trị mặc định nếu không hợp lệ
        }

        this.flightSpeedInput.value = flightSpeed; // Đảm bảo hiển thị số nguyên

        // Tính toán và cập nhật thời gian bay
        const newTime = this.calculateTime(flightSpeed, Math.round(this.totalDistanceFly / 1000));
        if (newTime === Infinity || isNaN(newTime)) {
            this.flightTimeInput.value = 0
            this.flightSpeedInput.value = 0

        } else {
            this.flightTimeInput.value = Math.round(newTime).toString(); // Hiển thị dưới dạng số nguyên
        }

    };

    /**
    * Xử lý sự kiện khi thay đổi chiều cao của camera so với móc path ban đầu
    */
    private validateAndHandleHeightCameraChange = () => {
        let heightCamera = parseInt(this.heightCameraInput.value, 10);

        // Kiểm tra giá trị hợp lệ
        if (isNaN(heightCamera) || heightCamera <= 0) {
            heightCamera = 0; // Gán giá trị mặc định nếu không hợp lệ
        }

        if (heightCamera === Infinity || isNaN(heightCamera)) {
            this.flightTimeInput.value = 0
        } else {
            this.heightCameraInput.value = heightCamera; // Đảm bảo hiển thị số nguyên
        }
    };


    /**
   * Xử lý sự kiện khi thay đổi góc nhìn của camera
   */
    private validateAndHandleAngleCameraChange = () => {
        let angleCamera = parseInt(this.angleCameraInput.value, 10); // Lấy giá trị từ input và chuyển sang số nguyên

        // Kiểm tra giá trị hợp lệ
        if (isNaN(angleCamera) || angleCamera <= 0) {
            angleCamera = 0; // Gán giá trị mặc định là 1 nếu không hợp lệ hoặc nhỏ hơn 0
        } else if (angleCamera > 75) {
            angleCamera = 75; // Giới hạn tối đa là 75
        }

        // Gán lại giá trị đã xử lý vào input
        this.angleCameraInput.value = angleCamera.toString(); // Đảm bảo hiển thị là chuỗi
    };



    points: any
    valueSpeedCam: number = 1;
    onTickListener: any;
    droneEntity: any
    pointDotFormKML: any = []
    finishDroneLine: any = {}
    // Hàm mới
    private isContinue = true;
    private moveCameraAlongPath = () => {
        this.showHideModalCameraSetting(false);
        this.pointDotFormKML = []; // làm rỗng dot trước
        // const listNameFile = this.checkedFiles.map((item: any) => item.name);
        this.points = this.getMergedPointKML(this.checkedFiles, Number(this.heightCameraInput.value));




        // Hủy sự kiện click point pick điểm
        if (this.handler) {
            this.handler.removeInputAction(ScreenSpaceEventType.LEFT_CLICK);
        }
        // Save current viewer.clock state so we can restore day/night/time settings later
        this.saveClockState();

        // Use the viewer's currentTime if it was previously set by the app so
        // the flight animation starts from the Cesium clock time you configured.
        // Fall back to JulianDate.now() if currentTime is not available.
        const start = (this.viewer && this.viewer.clock && this.viewer.clock.currentTime)
            ? this.viewer.clock.currentTime.clone()
            : JulianDate.now();
        const duration = Number(this.flightTimeInput.value);
        const stop = JulianDate.addSeconds(start, duration, new JulianDate());

        this.viewer.clock.startTime = start.clone();
        this.viewer.clock.stopTime = stop.clone();
        this.viewer.clock.currentTime = start.clone();
        this.viewer.clock.multiplier = 1.0;
        this.viewer.clock.shouldAnimate = true;


        let position = new SampledPositionProperty();


        // Vẽ các điểm lên bản đồ
        this.points.forEach((position111: any, index: number) => {

            const pointTemp = this.viewer.entities.add({
                position: position111,
                point: {
                    pixelSize: 6,
                    outlineColor: Color.GREEN,
                    outlineWidth: 2
                },
            });
            this.pointDotFormKML.push(pointTemp);

            const time = JulianDate.addSeconds(start, ((index + 1) / this.points.length) * duration, new JulianDate());
            position.addSample(time, position111);
        });

        let orientation = new VelocityOrientationProperty(position);

        this.droneEntity = this.viewer.entities.add({

            polyline: {
                positions: this.points,
                width: 10, // Độ dày của polyline
                material: new PolylineGlowMaterialProperty({
                    glowPower: 0.2, // Cường độ ánh sáng
                    color: Color.YELLOW, // Màu phát sáng
                }),
                orientation: orientation,  // Đảm bảo rằng orientation được thiết lập đúng
            },


        });


        let startP = this.points[0];
        let lens: any = [0]; // Khởi tạo lens với giá trị 0 cho điểm đầu tiên
        let sums = 0;
        let minLen = Number.MAX_VALUE;

        // Tính toán lens và sums
        for (let i = 1; i < this.points.length; ++i) {
            const distance = Cartesian3.distance(startP, this.points[i]);
            startP = this.points[i];
            sums += distance;
            if (distance > 1) minLen = Math.min(distance, minLen);

            // Cập nhật lens
            lens.push(lens[lens.length - 1] + distance);
        }
        // Tính toán times
        let times = [];
        for (let i = 0; i < lens.length; ++i) {
            times.push(lens[i] / sums);
        }

        // Kiểm tra để đảm bảo times.length === points.length
        if (times.length !== this.points.length) {
            console.error("times.length must be equal to points.length");
            return; // Hoặc bạn có thể xử lý tình huống khác nếu cần
        }

        // Tạo đối tượng LinearSpline
        const spline = new LinearSpline({
            times: times,
            points: this.points,
        });

        // Khởi tạo lại các mảng và bước tiếp theo
        var time1s = [];
        this.points = [];

        let step = minLen / sums;
        // console.log("step",step);
        for (let i = 0; i <= 1; i += step) {
            const position111 = spline.evaluate(i);
            time1s.push(i);
            this.points.push(position111);
        }
        const positionSpline = new CatmullRomSpline({
            times: time1s,
            points: this.points,
        });
        position = new SampledPositionProperty();
        // console.log("aaaa");

        // console.log("distanceFly", distanceFly);
        // if (distanceFly > 15) {

        //     step = 1.1 / this.points.length;

        // } else {
        //     step = 0.3 / this.points.length;

        // }
        // console.log("step", step);
        for (let i = 0; i <= 1; i += step) {

            if (i > 1) break; // Đảm bảo i không vượt quá 1.0

            let position111;
            try {
                position111 = positionSpline.evaluate(i);
            } catch (error) {
                console.warn(`Lỗi khi evaluate tại i=${i}:`, error);
                continue; // Bỏ qua nếu lỗi xảy ra
            }

            const time = JulianDate.addSeconds(start, i * duration, new JulianDate());

            if (JulianDate.greaterThan(time, stop)) {
                console.warn(`Thời gian vượt quá giới hạn: ${time.toString()}`);
                break;
            }

            position.addSample(time, position111);
        }

        orientation = new VelocityOrientationProperty(position);


        this.finishDroneLine.finish = false;




        const moveCamera = (clock: any) => {

            if (!this.viewer.clock.shouldAnimate) return;

            const currentTime = clock.currentTime;
            try {
                const timebetween = JulianDate.secondsDifference(currentTime, clock.startTime);
                const t = timebetween / duration;
                // console.log("t", t)
                if (t <= 1 && this.isContinue) {
                    // Lấy vị trí hiện tại trên spline
                    const position = positionSpline.evaluate(t);
                    const nextT = Math.min(t + 0.01, 1.0);


                    const nextPosition = positionSpline.evaluate(nextT);

                    const cartographic = Cartographic.fromCartesian(position);

                    var newPointZ = Cartesian3.fromDegrees(
                        (cartographic.longitude * 180) / Math.PI,
                        (cartographic.latitude * 180) / Math.PI,
                        cartographic.height + 10
                    );

                    const direction = Cartesian3.subtract(
                        nextPosition,
                        newPointZ,
                        new Cartesian3()
                    );
                    Cartesian3.normalize(direction, direction);

                    const updirection = Cartesian3.subtract(
                        newPointZ,
                        position,
                        new Cartesian3()
                    );
                    Cartesian3.normalize(updirection, updirection);

                    let finalDirection = direction;
                    let finalUp = updirection;

                    const right = Cartesian3.cross(direction, updirection, new Cartesian3());
                    if (Cartesian3.magnitudeSquared(right) > 1e-6) {
                        Cartesian3.normalize(right, right);
                        const forward = Cartesian3.cross(updirection, right, new Cartesian3());
                        Cartesian3.normalize(forward, forward);

                        const angleCamera = (this.angleCameraInput && this.angleCameraInput.value !== "")
                            ? Number(this.angleCameraInput.value)
                            : 15;
                        const angleRad = MathCesium.toRadians(angleCamera);
                        const cosAngle = Math.cos(angleRad);
                        const sinAngle = Math.sin(angleRad);

                        finalDirection = new Cartesian3(
                            forward.x * cosAngle - updirection.x * sinAngle,
                            forward.y * cosAngle - updirection.y * sinAngle,
                            forward.z * cosAngle - updirection.z * sinAngle
                        );
                        Cartesian3.normalize(finalDirection, finalDirection);

                        finalUp = new Cartesian3(
                            updirection.x * cosAngle + forward.x * sinAngle,
                            updirection.y * cosAngle + forward.y * sinAngle,
                            updirection.z * cosAngle + forward.z * sinAngle
                        );
                        Cartesian3.normalize(finalUp, finalUp);
                    }

                    // Cập nhật camera
                    this.viewer.scene.camera.setView({
                        destination: newPointZ,
                        orientation: {
                            direction: finalDirection,
                            up: finalUp,
                        },
                    });
                    if (nextT + step >= 1) {
                        this.isContinue = false;
                        //drawPathFromDroneEntity(droneEntity);
                        // remove tick listener and restore the saved clock state
                        if (this.onTickListener) {
                            this.viewer.clock.onTick.removeEventListener(this.onTickListener);
                            this.onTickListener = null;
                        }
                        this.restoreClockState();
                        this.viewer.camera.lookAtTransform(Matrix4.IDENTITY);
                        // Vẽ lại toàn bộ đường cong sau khi di chuyển kết thúc
                        console.log("Animation finished");
                        return;
                    }
                }
                // console.log("entityPosition", entityPosition);
                // console.log("entityOrientation", entityOrientation);
                // if (!entityPosition || !entityOrientation) {

                //     //drawPathFromDroneEntity(droneEntity);
                //     this.viewer.clock.shouldAnimate = false;
                //     this.viewer.clock.onTick.removeEventListener(this.onTickListener);
                //     this.onTickListener = null;
                //     this.viewer.camera.lookAtTransform(Matrix4.IDENTITY);
                //     // Vẽ lại toàn bộ đường cong sau khi di chuyển kết thúc

                //     console.log("Animation finished");
                //     return
                // };
            } catch (error) {
                console.log("error", error)
                //drawPathFromDroneEntity(droneEntity);
                if (this.onTickListener) {
                    this.viewer.clock.onTick.removeEventListener(this.onTickListener);
                    this.onTickListener = null;
                }
                this.restoreClockState();
                this.viewer.camera.lookAtTransform(Matrix4.IDENTITY);
                // Vẽ lại toàn bộ đường cong sau khi di chuyển kết thúc
                console.log("Animation finished");
            }
        }

        this.onTickListener = this.viewer.clock.onTick.addEventListener(moveCamera);
    }




    //Hàm gộp Point lại nếu khi chạy chung
    private getMergedPointKML = (listNameFile: string[], zOffset: number) => {
        if (!zOffset) {
            zOffset = 0
        }

        // Lọc và gộp tất cả các pointKML của các phần tử có tên trùng với listNameFile
        return this.dataSources
            .filter((item: any) => listNameFile.includes(item.name))  // Lọc các phần tử có name trùng với listNameFile
            .flatMap((item: any) => {
                // Điều chỉnh zOffset cho mỗi pointKML
                return item.pointKML.map((position: any) => {
                    const cartographic = Cartographic.fromCartesian(position);
                    cartographic.height += zOffset; // Tăng giá trị z lên zOffset
                    return Cartesian3.fromRadians(
                        cartographic.longitude,
                        cartographic.latitude,
                        cartographic.height
                    );
                });
            });
    }

    //Hàm tạm dừng hoặc chạy tiếp cho camera
    playCameraMove = (play: boolean) => {
        if (this.onTickListener) {
            this.viewer.clock.shouldAnimate = play;
            if (!play) {
                this.viewer.camera.lookAtTransform(Matrix4.IDENTITY);
                this.viewer.clock.shouldAnimate = false;
                // this.viewer.clock.onTick.removeEventListener(this.onTickListener);
                // this.onTickListener = null;
            }
        }
    }

    //Hàm tăng giảm tốc độ cho camera
    speedCameraMove = (accelerate: boolean) => {
        if (accelerate) {
            this.valueSpeedCam *= 2;
        } else {
            this.valueSpeedCam /= 2;

        }
        this.viewer.clock.multiplier = this.valueSpeedCam
    }

    //Hàm reset trả về ban đầu cho camera
    resetCameraMove = () => {
        if (this.pointDotFormKML) {
            //Xóa hết tất cả các point 
            this.pointDotFormKML.forEach((point: any) => {
                this.viewer.entities.remove(point)
            })
            //Xóa drone
            this.viewer.entities.remove(this.droneEntity)
        }
        if (this.finishDroneLine) {
            this.viewer.entities.remove(this.finishDroneLine.droneLine);
            this.finishDroneLine = {}
        }
        if (this.onTickListener) {

            this.viewer.camera.lookAtTransform(Matrix4.IDENTITY);
            this.viewer.clock.shouldAnimate = false;
            this.viewer.clock.onTick.removeEventListener(this.onTickListener);
            this.onTickListener = null;
        }
        this.isContinue = true;
        // if (this.modal && this.modal.parentNode) {
        //     this.modal.parentNode.removeChild(this.modal); // Xóa khỏi DOM
        //     this.modal = null; // Loại bỏ tham chiếu trong mã
        // }

        this.viewer.scene.requestRender()

    }

    /**
     * Save the current viewer.clock state (times, multiplier, shouldAnimate)
     * so the app's global time-of-day / lighting won't be permanently changed
     * by the fly-camera animation.
     */
    private saveClockState = () => {
        try {
            if (!this.viewer || !this.viewer.clock) return;
            const clock = this.viewer.clock;
            this.savedClockState = {
                startTime: clock.startTime && clock.startTime.clone ? clock.startTime.clone() : undefined,
                stopTime: clock.stopTime && clock.stopTime.clone ? clock.stopTime.clone() : undefined,
                currentTime: clock.currentTime && clock.currentTime.clone ? clock.currentTime.clone() : undefined,
                multiplier: clock.multiplier,
                shouldAnimate: clock.shouldAnimate,
            };
        } catch (e) {
            console.warn('Failed to save viewer.clock state', e);
        }
    }

    /**
     * Restore previously saved viewer.clock state, if available.
     */
    private restoreClockState = () => {
        try {
            if (!this.viewer || !this.viewer.clock || !this.savedClockState) return;
            const clock = this.viewer.clock;
            if (this.savedClockState.startTime) clock.startTime = this.savedClockState.startTime.clone();
            if (this.savedClockState.stopTime) clock.stopTime = this.savedClockState.stopTime.clone();
            if (this.savedClockState.currentTime) clock.currentTime = this.savedClockState.currentTime.clone();
            if (typeof this.savedClockState.multiplier === 'number') clock.multiplier = this.savedClockState.multiplier;
            if (typeof this.savedClockState.shouldAnimate === 'boolean') clock.shouldAnimate = this.savedClockState.shouldAnimate;
            this.savedClockState = null;
        } catch (e) {
            console.warn('Failed to restore viewer.clock state', e);
        }
    }

    //Hàm triển ẩn hiện point line bay
    showHidePointPath = (showPoints: boolean) => {
        this.pointDotFormKML.forEach((point: any) => {
            point.show = showPoints
        })

        this.droneEntity.show = showPoints

        if (this.finishDroneLine.finish) {
            this.finishDroneLine.droneLine.show = showPoints;
        }
        this.viewer.scene.requestRender()
    }







}